import List from "@/components/list";
import vue from "@/main";
import router from "@/router";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  // 编辑考试
  function editExam({ uuid }) {
    router.push({ path: "/examInfo/edit", query: { id: uuid } });
  }

  // 删除考试
  function deleteExam(exam) {
    vue.$emit("deleteExam", exam);
  }

  // 查看考试人员
  function examUserList(exam) {
    router.push({
      path: "/examInfo/members",
      query: {
        id: exam.uuid,
        examType: exam.examType,
        status: exam.examStatus,
        bizId: exam.bizId
      }
    });
  }

  // 跳转试卷详情
  function goPaperDetail(item) {
    router.push({ path: "/examPaper/detail", query: { id: item.paperId } });
  }
  // 跳转考试详情
  function goDetails(item) {
    router.push({ path: "/examInfo/detail", query: { id: item.uuid } });
  }

  const PaperName = ({ props: { vo } }) => {
    return (
      <div class="base-hover-char" onClick={() => goPaperDetail(vo.row)}>
        {vo.row.paperName}
      </div>
    );
  };

  const Deal = ({ props: { vo } }) => {
    const exam = vo.row;
    const dealConf = [
      ["icon-message", "详情", () => goDetails(exam), ""],
      [
        exam.publishStatus === 0 ? "icon-edit" : "icon-edit-disable",
        "编辑",
        exam.publishStatus === 0
          ? () => {
              editExam(exam);
            }
          : () => {},
        "examInfo:update"
      ],
      [
        exam.publishStatus === 0 ? "icon-delete" : "icon-delete-disable",
        "删除",
        exam.publishStatus === 0
          ? () => {
              deleteExam(exam);
            }
          : () => {},
        "examInfo:delete"
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
        <el-tooltip content="考试学员名单" placement="top">
          <i class="icon-user-list" onClick={() => examUserList(exam)}></i>
        </el-tooltip>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "试卷名称",
      prop: "paperName",
      minWidth: "220",
      fixed: 'left',
      render: (vo) => <PaperName vo={vo} />,
    },
    {
      label: "考试类型",
      prop: "examTypeName",
      width: "90",
      showOverflowTooltip: true
    },
    {
      label: "发布状态",
      prop: "publishStatusName",
      width: "90",
      showOverflowTooltip: true
    },
    {
      label: "考试状态",
      prop: "examStatusName",
      width: "90",
      showOverflowTooltip: true
    },
    {
      label: "考试时间",
      width: "250",
      prop: "limitTime"
    },
    {
      label: "关联班级",
      prop: "bizName",
      minWidth: "180",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      width: "180",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      fixed: "right",
      width: "150",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
